const VerticalDivider = () => {
  return <div className="separator vertical" />;
};

export default VerticalDivider;
